import { useState, useEffect } from 'react'
import EditFinalSale from './editFinalSale'
import Spinner from 'react-bootstrap/Spinner'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons'
import BaseService from '../../../services/BaseService'
import DataGrid from '../../GenericComponents/DataGrid'
import { Column } from 'primereact/column'
import CommonService from "../../../services/CommonService"

const SearchResultContainer = (props) => {
  const [editFinalSale, setEditFinalSale] = useState(false);
  const [selectedFinalSaleInfo, setSelectedFinalSaleInfo] = useState([]);
  const {finalSaleId} = props;
  const [cdiacFinalSale, setCdiacFinalSale] = useState([])
  const [isLoading, setIsLoading] = useState(true);

  const viewEditFormatter = (row) => {
    return (
      <div style={{
        textAlign: "center",
        lineHeight: "normal"
      }}>
        <FontAwesomeIcon icon={faPencilAlt} className="custom-icon" onClick={(e)=>onRowClick(e, row)}/> 
      </div>
    );
  }
  const onRowClick = (e, row) => {
    // e.preventDefault();
    setSelectedFinalSaleInfo(row);
    setEditFinalSale(true);
  }

  const getFinalSale = () => {
    var obj = {
      msgId: null,
      sysId: null,
      opr: "getFinalSaleById",
      hdrStruct: null,
      queryParam: null,
      reqData: {
          "finalSaleId": finalSaleId,
          "tableType": "Normal",
      },
    };

    BaseService.processRequest(obj)
      .then((res) => res)
      .then((result) => {
        Object.keys(result.data.responses).forEach((key) => {
          setCdiacFinalSale(result.data.responses[key]);
        });
        setIsLoading(false);
      });
  }
  useEffect(() => {
    if (finalSaleId){
      getFinalSale();
    }
    // eslint-disable-next-line
  }, [finalSaleId]);

  const columns = [{
    dataField: 'issuerName',
    text: 'Issuer Name',
    sort: true,
  }, {
    dataField: 'projectName',
    text: 'Project Name',
    sort: true,
  }, {
    dataField: 'principalSaleAmt',
    text: 'Principal Sale Amount',
    sort: true,
    formatter: (row) => CommonService.currencyFormatter(row.principalSaleAmt),
  }, {
    dataField: 'settlementDate',
    text: 'Settlement Date',
    sort: true,
    formatter: (row) => CommonService.dateFormatter(row.settlementDate),
  }, {
    dataField: "",
    text: "Action",
    formatter: viewEditFormatter,
  }
  ];

  const handleModalClose = () => {
    setEditFinalSale(false);
    getFinalSale();
  }

  return (
    <>
      <hr/>
      {isLoading && <Spinner animation="border" variant="primary" />}
      <div className="form">
        <h2>Search Result: </h2>
        <DataGrid
            title="Report of Final Sale"
            dataSource={cdiacFinalSale}
            sortField='finalSaleId'
            searchToolTip="Use the search feature to quickly retrieve the system code values"
            emptyDataMessage='No data available to display'
            >
            {columns.map((column, i) => {
                return (
                <Column 
                key={i}
                field={column.dataField}
                header={column.text}
                sortable={column.sort} 
                body={column.formatter}
                hidden={column.hidden}
                />)
                }) 
            } 
        </DataGrid>
      </div>
      {editFinalSale && <EditFinalSale onModalClose={() => handleModalClose()} finalSaleInfo={selectedFinalSaleInfo} />}
    </>
  )
}

export default SearchResultContainer
